<form action="" [formGroup]="intiativeForm">
  <h5 class="sub-title mb-3">{{ datas.title }} Initiatives</h5>
  <div class="row">
    <div class="col-lg-9 col-md-9 col-sm-12 col-12">
      <h5 class="sub-title mb-3">Banner Section</h5>
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label>Title<span class="text-danger">*</span></mat-label>
              <input
                matInput
                placeholder="Enter Title"
                formControlName="title"
                [ngClass]="{
                  'is-invalid': add.title.touched && add.title.errors
                }"
              />
              <mat-error *ngIf="add.title.touched && add.title.errors">
                <span *ngIf="add.title.errors.required">Title is required</span>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Apply Button Link <span class="text-danger">*</span></mat-label
              >
              <input
                matInput
                placeholder="Enter Apply Button Link"
                formControlName="redirectLink"
                [ngClass]="{
                  'is-invalid':
                    add.redirectLink.touched && add.redirectLink.errors
                }"
              />
              <mat-error
                *ngIf="add.redirectLink.touched && add.redirectLink.errors"
              >
                <span *ngIf="add.redirectLink.errors.required"
                  >Apply Button Link is required</span
                >
                <span *ngIf="add.redirectLink.errors.url"
                  >Please enter proper url format</span
                >
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <h5 class="sub-title mb-3">Board Section</h5>
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Board Title<span class="text-danger">*</span></mat-label
              >
              <input
                matInput
                placeholder="Enter Board Title"
                formControlName="aboutusTitle"
                [ngClass]="{
                  'is-invalid':
                    add.aboutusTitle.touched && add.aboutusTitle.errors
                }"
              />
              <mat-error
                *ngIf="add.aboutusTitle.touched && add.aboutusTitle.errors"
              >
                <span *ngIf="add.aboutusTitle.errors.required"
                  >Board Title is required</span
                >
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Board Content<span class="text-danger">*</span></mat-label
              >
              <input
                matInput
                placeholder="Enter Board Content"
                formControlName="aboutusContent"
                [ngClass]="{
                  'is-invalid':
                    add.aboutusContent.touched && add.aboutusContent.errors
                }"
              />
              <mat-error
                *ngIf="add.aboutusContent.touched && add.aboutusContent.errors"
              >
                <span *ngIf="add.aboutusContent.errors.required"
                  >Board Content is required</span
                >
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <h5 class="sub-title mb-3">Matrix Section</h5>
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Matrix Name 1<span class="text-danger">*</span></mat-label
              >
              <input
                matInput
                placeholder="Enter Matrix Name 1"
                formControlName="matrixName1"
                [ngClass]="{
                  'is-invalid':
                    add.matrixName1.touched && add.matrixName1.errors
                }"
              />
              <mat-error
                *ngIf="add.matrixName1.touched && add.matrixName1.errors"
              >
                <span *ngIf="add.matrixName1.errors.required"
                  >Matrix Name 1 is required</span
                >
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Matrix Value 1<span class="text-danger">*</span></mat-label
              >
              <input
                matInput
                placeholder="Enter Matrix Value 1"
                formControlName="matrixValue1"
                [ngClass]="{
                  'is-invalid':
                    add.matrixValue1.touched && add.matrixValue1.errors
                }"
              />
              <mat-error
                *ngIf="add.matrixValue1.touched && add.matrixValue1.errors"
              >
                <span *ngIf="add.matrixValue1.errors.required"
                  >Matrix Value 1 is required</span
                >
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Matrix Name 2<span class="text-danger">*</span></mat-label
              >
              <input
                matInput
                placeholder="Enter Matrix Name 2"
                formControlName="matrixName2"
                [ngClass]="{
                  'is-invalid':
                    add.matrixName2.touched && add.matrixName2.errors
                }"
              />
              <mat-error
                *ngIf="add.matrixName2.touched && add.matrixName2.errors"
              >
                <span *ngIf="add.matrixName2.errors.required"
                  >Matrix Name 2 is required</span
                >
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Matrix Value 2<span class="text-danger">*</span></mat-label
              >
              <input
                matInput
                placeholder="Enter Matrix Value 2"
                formControlName="matrixValue2"
                [ngClass]="{
                  'is-invalid':
                    add.matrixValue1.touched && add.matrixValue2.errors
                }"
              />
              <mat-error
                *ngIf="add.matrixValue2.touched && add.matrixValue2.errors"
              >
                <span *ngIf="add.matrixValue2.errors.required"
                  >Matrix Value 2 is required</span
                >
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Matrix Name 3<span class="text-danger">*</span></mat-label
              >
              <input
                matInput
                placeholder="Enter Matrix Name 3"
                formControlName="matrixName3"
                [ngClass]="{
                  'is-invalid':
                    add.matrixName3.touched && add.matrixName3.errors
                }"
              />
              <mat-error
                *ngIf="add.matrixName3.touched && add.matrixName3.errors"
              >
                <span *ngIf="add.matrixName3.errors.required"
                  >Matrix Name 3 is required</span
                >
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Matrix Value 3<span class="text-danger">*</span></mat-label
              >
              <input
                matInput
                placeholder="Enter Matrix Value 3"
                formControlName="matrixValue3"
                [ngClass]="{
                  'is-invalid':
                    add.matrixValue3.touched && add.matrixValue3.errors
                }"
              />
              <mat-error
                *ngIf="add.matrixValue3.touched && add.matrixValue3.errors"
              >
                <span *ngIf="add.matrixValue3.errors.required"
                  >Matrix Value 3 is required</span
                >
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="d-flex">
        <h5 class="sub-title mb-3">Benefit Section</h5>
        <div class="ml-auto">
          <i
            class="fas fa-plus-circle adddoc-icon"
            (click)="addRow(aboutUs.length)"
          ></i>
          Add Benefits
        </div>
      </div>
      <div *ngFor="let item of array.controls; let ind = index">
        <div [formGroup]="item">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Benefit Title<span class="text-danger">*</span></mat-label
                  >
                  <input
                    matInput
                    placeholder="Enter Benefit Title"
                    formControlName="benefitTitle"
                    [ngClass]="{
                      'is-invalid':
                        item.controls.benefitTitle.touched &&
                        item.controls.benefitTitle.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      item.controls.benefitTitle.touched &&
                      item.controls.benefitTitle.errors
                    "
                  >
                    <span *ngIf="item.controls.benefitTitle.errors.required"
                      >Benefit Title is required</span
                    >
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="form-rows">
                <mat-form-field
                  class="material-full-width"
                  appearance="outline"
                >
                  <mat-label
                    >Benefit Content<span class="text-danger"
                      >*</span
                    ></mat-label
                  >
                  <input
                    matInput
                    placeholder="Enter Benefit Content"
                    formControlName="benefitContent"
                    [ngClass]="{
                      'is-invalid':
                        item.controls.benefitContent.touched &&
                        item.controls.benefitContent.errors
                    }"
                  />
                  <mat-error
                    *ngIf="
                      item.controls.benefitContent.touched &&
                      item.controls.benefitContent.errors
                    "
                  >
                    <span *ngIf="item.controls.benefitContent.errors.required"
                      >Benefit Content is required</span
                    >
                  </mat-error>
                </mat-form-field>
                <span
                  class="delete-span"
                  (click)="deleteValue(item.controls.id.value, ind)"
                >
                  <i class="fas fa-trash delete-i" aria-hidden="true"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <h5 class="sub-title mb-3">Pointer Section</h5>
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="form-rows">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Pointer Title<span class="text-danger">*</span></mat-label
              >
              <input
                matInput
                placeholder="Enter Pointer Title"
                formControlName="pointersTitle"
                [ngClass]="{
                  'is-invalid':
                    add.pointersTitle.touched && add.pointersTitle.errors
                }"
              />
              <mat-error
                *ngIf="add.pointersTitle.touched && add.pointersTitle.errors"
              >
                <span *ngIf="add.pointersTitle.errors.required"
                  >Pointer Title is required</span
                >
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-12 col-md-6 col-sm-12 col-12">
          <div class="form-rows">
            <mat-label
              >Pointer Description <span class="text-danger">*</span></mat-label
            >
            <ckeditor
              [editor]="Editor"
              formControlName="pointers"
              [ngClass]="{
                'is-invalid': add.pointers.touched && add.pointers.errors
              }"
              (ready)="onReady($event)"
              (change)="onChange($event)"
            >
            </ckeditor>
            <mat-error *ngIf="add.pointers.touched && add.pointers.errors">
              <span *ngIf="add.pointers.errors.required"
                >Pointer Description is required</span
              >
              <p *ngIf="img == 'show'" class="text-danger">Format is invalid</p>
            </mat-error>
          </div>
        </div>
      </div>
      <h5 class="sub-title mb-3 mt-3">Slogan Section</h5>
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="form-rows mt-2">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Slogan Content<span class="text-danger">*</span></mat-label
              >
              <input
                matInput
                placeholder="Enter Slogen Content"
                formControlName="sloganContent"
                [ngClass]="{
                  'is-invalid':
                    add.sloganContent.touched && add.sloganContent.errors
                }"
              />
              <mat-error
                *ngIf="add.sloganContent.touched && add.sloganContent.errors"
              >
                <span *ngIf="add.sloganContent.errors.required"
                  >Slogen Content is required</span
                >
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <h5 class="sub-title mb-3">Menu Section</h5>
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="form-rows mt-3">
            <mat-form-field class="material-full-width" appearance="outline">
              <mat-label
                >Menu Order<span class="text-danger">*</span></mat-label
              >
              <input
                matInput
                placeholder="Enter Menu Order"
                formControlName="menuOrder"
                type="number"
                [ngClass]="{
                  'is-invalid': add.menuOrder.touched && add.menuOrder.errors
                }"
              />
              <mat-error *ngIf="add.menuOrder.touched && add.menuOrder.errors">
                <span *ngIf="add.menuOrder.errors.required"
                  >Menu Order is required</span
                >
                <span *ngIf="add.menuOrder.errors.pattern">
                  <i class="fas fa-exclamation-triangle"></i>
                  Menu Order is Invalid
                </span>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
          <mat-label>Show Menu<span class="text-danger">*</span></mat-label>
          <div class="form-rows">
            <mat-button-toggle-group
              formControlName="showInMenu"
              [value]="add.showInMenu.value"
            >
              <mat-button-toggle
                value="true"
                [ngClass]="{ 'is-selected': add.showInMenu.value === true }"
                >Yes</mat-button-toggle
              >
              <mat-button-toggle
                value="false"
                [ngClass]="{ 'is-selected': add.showInMenu.value === false }"
                >No</mat-button-toggle
              >
            </mat-button-toggle-group>
            <mat-error *ngIf="add.showInMenu.touched && add.showInMenu.errors">
              <span *ngIf="add.showInMenu.errors.required"
                >Show in Menu is required</span
              >
            </mat-error>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-3 col-md-3 col-sm-12 col-12">
      <div class="p-relative">
        <p class="logo-span">
          Initiatives Banner Image <span class="text-danger">*</span>
        </p>
        <div class="text-center">
          <div class="circle">
            <img class="profile-pic" [src]="image_url1" />
          </div>
          <div>
            <label for="files1" class="p-image">Upload Banner Image</label>
            <input
              class="file-upload"
              (change)="onSelectImage($event)"
              id="files1"
              type="file"
              accept="image/*"
            />
          </div>
        </div>
        <p>
          <span class="noti-span"
            >(Supported Format: png, jpg, jpeg) <br />(Suggested Image
            Dimensions: 1440 x 465)<br />(Max file size: 10MB)</span
          >
        </p>
        <p *ngIf="logoCheck == true" class="text-danger">
          Banner Image is required
        </p>
        <p
          *ngIf="
            filesize &&
            selecetdImage &&
            selecetdImage.size / (1024 * 1024) > maxSizeMB
          "
          class="text-danger"
        >
          File size exceeds the limit ({{ maxSizeMB }}MB)
        </p>
      </div>

      <div class="form-rows mt-lg-5">
        <div class="p-relative">
          <p class="logo-span">
            Initiatives Logo Image <span class="text-danger">*</span>
          </p>
          <div class="text-center">
            <div class="circle">
              <img class="profile-pic" [src]="image_url2" />
            </div>
            <div>
              <label for="files2" class="p-image">Upload Logo Image</label>
              <input
                class="file-upload"
                (change)="onSelectImage2($event)"
                id="files2"
                type="file"
                accept="image/*"
              />
            </div>
          </div>
          <p>
            <span class="noti-span"
              >(Supported Format: png,jpg,jpeg) <br />(Suggested Image
              Dimensions: 253 x 74)<br />(max file size: 10mb)</span
            >
          </p>
          <p *ngIf="logoCheck2 == true" class="text-danger">
            Logo Image is required
          </p>
          <p
            *ngIf="
              filesize3 &&
              selecetdImage2 &&
              selecetdImage2.size / (1024 * 1024) > maxSizeMB
            "
            class="text-danger"
          >
            File size exceeds the limit ({{ maxSizeMB }}MB)
          </p>
        </div>
      </div>
      <div class="form-rows mt-lg-5">
        <div class="p-relative">
          <p class="logo-span">
            Initiatives About Image <span class="text-danger">*</span>
          </p>
          <div class="text-center">
            <div class="circle">
              <img class="profile-pic" [src]="image_url3" />
            </div>
            <div>
              <label for="files3" class="p-image">Upload About Image</label>
              <input
                class="file-upload"
                (change)="onSelectImage3($event)"
                id="files3"
                type="file"
                accept="image/*"
              />
            </div>
          </div>
          <p>
            <span class="noti-span"
              >(Supported Format: png,jpg,jpeg) <br />(Suggested Image
              Dimensions: 459 x 482)<br />(max file size: 10mb)</span
            >
          </p>
          <p *ngIf="logoCheck3 == true" class="text-danger">
            About Image is required
          </p>
          <p
            *ngIf="
              filesize3 &&
              selecetdImage3 &&
              selecetdImage3.size / (1024 * 1024) > maxSizeMB
            "
            class="text-danger"
          >
            File size exceeds the limit ({{ maxSizeMB }}MB)
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="form-rows">
    <div class="col-lg-12 col-md-6 col-sm-12 col-12">
      <div class="text-center">
        <button
          mat-raised-button
          class="mr-2 new-btn-color"
          color="primary"
          (click)="saveInitiatives()"
          *ngIf="sample != 2"
        >
          {{ savelbl }}
        </button>
        <button
          class="mr-2 new-btn-color2"
          mat-raised-button
          color="warn"
          (click)="cancelInitiatives()"
        >
          Cancel</button
        ><br />
      </div>
    </div>
  </div>
</form>
